import { Component } from "react"

/* Widgets */
import RoundView from "../Round/RoundView"

/* Registry */
import { multi } from "../Round/registry"


/* Widget GameInformation — THE ROUND OF A MULTI PLAYER POKER TABLE */
class GameInformation extends Component {

    render = () => {

        /* Fields */
        const { uid, gameID, postfix, socket } = this.props

        return <RoundView api={multi.api} config={multi} uid={uid} gameID={gameID} postfix={postfix} socket={socket} />
    }

}

export default GameInformation
